import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { StickyContainer } from 'react-sticky'
import { Helmet } from 'react-helmet'

import Header from '../components/Global/Header'
import * as Grid from '../components/Grid'
import Feature from '../components/Global/Feature'
import ServiceContainer from '../components/Global/ServiceContainer'
import CodeContainer from '../components/Global/CodeContainer'
import Footer from '../components/Global/Footer'

import { GlobalStyle } from '../styles/reset.css'

import media from '../styles/media'

import background from '../images/home/background.png'
import ill from '../images/home/ill.png'
import cloud from '../images/home/cloud.svg'
import network from '../images/home/network.svg'
import server from '../images/home/server.svg'

import favicon from '../assets/favicon.ico'

const Background = styled.div`
  display: flex;
  background-color: #f8f9fa;
  background-image: url(${props => props.background});
  background-size: contain;
  background-repeat: no-repeat;
`

const MainTitle = styled.h1`
  color: #007bff;
  font-size: 1.5rem;

  ${media.md` 
    font-weight: bold;  
    font-size: 2rem;
  `}

  ${media.lg` 
    font-weight: bold;  
    font-size: 3rem;
  `}
`

const SubTitle = styled.p`
  color: #7a7878;
  font-weight: 400;
  font-size: 1rem;

  ${media.md` 
    font-weight: bold;  
    font-size: 1.25rem;
  `}
`

const SectionButton = styled.div`
  margin: 15px 0;
  display: flex;
  ${media.md` 
    margin-top: 0;
  `}
`

const ButtonLeft = styled(Link)`
  border: 1px solid #008de6;
  border-radius: 3px;
  background-color: #007bff;
  color: white;
  margin-right: 10px;
  padding: 0.5rem 1rem;
  text-decoration: none;
  text-transform: uppercase;

  ${media.md` 
    padding: 0.5rem 1.75rem;
  `}
`

const ButtonRight = styled(Link)`
  border: 1px solid #008de6;
  border-radius: 3px;
  background-color: #007bff;
  color: white;
  margin-left: 10px;
  padding: 0.5rem 1rem;
  text-decoration: none;
  text-transform: uppercase;

  ${media.md` 
    padding: 0.5rem 1.75rem;
  `}
`

const SkypostalDevelopersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;

  ${media.md`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3rem 0;
  `};
`

const SkypostalDevelopers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media.md`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `};
`
const SkypostalDevelopersImage = styled.div`
  display: none;
  ${media.md`
    display: flex;
    padding: 3rem;
  `}
`

const FeatureContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${media.md`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
  `};
`

function Home() {
  return (
    <StickyContainer>
      <Helmet
        title="SkyPostal Developers"
        meta={[
          { name: 'description', content: '...' },
          { name: 'keywords', content: '....' }
        ]}
        link={[{ rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }]}
      />
      <GlobalStyle />
      <Header />
      <Background background={background}>
        <Grid.Container>
          <Grid.Row>
            <Grid.Column>
              <SkypostalDevelopersContainer>
                <SkypostalDevelopers>
                  <MainTitle>SkyPostal Developers</MainTitle>
                  <SubTitle>Easy to Integrate Logistics API</SubTitle>
                  {/* <SectionButton>
                    <ButtonLeft to="/api-box">API-BOX</ButtonLeft>
                    <ButtonRight to="/api-skypostal">API-SKYPOSTAL</ButtonRight>
                  </SectionButton>
                  <SectionButton>
                    <ButtonLeft to="/api-skypostal-current">
                      API-CURRENT
                    </ButtonLeft>
                  </SectionButton> */}
                </SkypostalDevelopers>
                <SkypostalDevelopersImage>
                  <img src={ill} alt={ill} />
                </SkypostalDevelopersImage>
              </SkypostalDevelopersContainer>
            </Grid.Column>
          </Grid.Row>
        </Grid.Container>
      </Background>
      <div style={{ display: 'flex' }}>
        <Grid.Container>
          <Grid.Row>
            <Grid.Column md={12}>
              <FeatureContainer>
                <Feature
                  img={cloud}
                  title="Secure Cloud API"
                  detail=""
                />
                <Feature
                  img={server}
                  title="24/7 Service"
                  detail=""
                />
                <Feature
                  img={network}
                  title="Scalable Services"
                  detail=""
                />
              </FeatureContainer>
            </Grid.Column>
          </Grid.Row>
        </Grid.Container>
      </div>
      <div
        style={{
          display: 'flex',
          backgroundColor: '#f8f9fa',
          padding: '3rem 0'
        }}
      >
        <ServiceContainer />
      </div>
      <div
        style={{
          display: 'flex',
          padding: '3rem 0'
        }}
      >
        <CodeContainer />
      </div>
      <div
        style={{
          display: 'flex',
          padding: '3rem 0',
          backgroundColor: '#f8f9fa'
        }}
      >
        <Footer />
      </div>
    </StickyContainer>
  )
}

export default Home
